import { ClientUserState } from '../../../../../shared/scripts/ClientUserState.ts';
import { UIMHeaderProfileController } from './UIMHeaderProfileController.ts';
import { setElementInnerHTML, setElementOnClick } from '../../../../../shared/scripts/ui_utils/DomUtils.ts';
import { UIHeaderController } from '../../../../../shared/scripts/ui_html/header/UIHeaderController.ts';
import { uiManager } from '../../../EntryMobile.ts';
import { MatchmakingMatchTypes } from '@colonist/game-base-types';
export class UIMHeaderController extends UIHeaderController {
    hide() {
        this.headerContainer.style.display = 'none';
    }
    show() {
        this.headerContainer.style.display = 'flex';
    }
    updateHeaderData() {
        const profileContainer = document.getElementById('header-element-profile-container');
        setElementOnClick(profileContainer, ()=>uiManager.mainpageController.profileOverlayController.show());
        if (ClientUserState.userState == undefined) return;
        const userNameElement = document.getElementById('header-element-profile-name');
        const karmaElement = document.getElementById('header-element-profile-karma');
        userNameElement.innerText = ClientUserState.userState.username;
        setElementInnerHTML(karmaElement, ClientUserState.userState.getPlayerKarmaStatusText());
        this.profileController.updateMembershipIcon(ClientUserState.userState);
        const iconElement = document.getElementById('header-element-profile-avatar');
        UIMHeaderProfileController.updateIcon(ClientUserState.userState.icon, iconElement);
    }
    handleShuffleLink(link) {
        link.removeAttribute('href');
        setElementOnClick(link, ()=>{
            var _this_notificationPanelController;
            (_this_notificationPanelController = this.notificationPanelController) === null || _this_notificationPanelController === void 0 ? void 0 : _this_notificationPanelController.hideNotificationPanel();
            void uiManager.goToMainPageAndSelectMatchType(MatchmakingMatchTypes.UnrankedShuffle);
            UIMHeaderController.sendPlayNowClickAnalytic();
        }, true);
    }
    constructor(){
        super();
        this.headerContainer = document.getElementById('header-container');
        this.profileController = new UIMHeaderProfileController();
        ClientUserState.registerChangeListener(()=>{
            this.updateHeaderData();
        });
    }
}
